module.exports = __webpack_public_path__ + "static/media/Logo.b73ba39f.png";